
import { firebase } from '../hooks/wm-firebase';
import { getDatabase, ref, onValue} from "firebase/database";



let fetching = false; 

const observeOrder = (orderRequest,debug, callback) => {   
    if(fetching){
        return; 
    }

    fetching=true;
    firebase(debug); 
    const db = getDatabase();
    const path = `${orderRequest.location}/KANBAN/${orderRequest.rtId}`; 
    const starCountRef = ref(db, path);

    onValue(starCountRef, (snapshot) => {
      const rtOrder = snapshot.val();
      callback(rtOrder); 
    });

    fetching=false;
}

export default observeOrder